/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./HousekeepingContent2.css";

/* ==== IMAGES (use real icons here) ==== */
import IconTrusted from "../Image/HouseKeeping/Housekeeping1.png";
import IconCoverage from "../Image/HouseKeeping/Housekeeping1.png";
import IconCompliance from "../Image/HouseKeeping/Housekeeping1.png";


const HousekeepingContent = () => {
  return (
    <div>
    <section className="hk2-wrapper">

      {/* TAG */}
      <div className="hk2-tag">About This Service</div>

      {/* TITLE */}
      <h2 className="hk2-title">Housekeeping & Janitorial Services</h2>
      <div className="hk2-underline"></div>

      {/* CONTENT BOX */}
      <div className="hk2-box">
        <p>
          Our housekeeping teams help organisations maintain a spotless, hygienic and 
          productive environment. Every site receives trained staff, structured checklists, 
          supervision and periodic quality audits. We focus on maintaining workstations, 
          washrooms, common areas, production floors, cafeterias and guest spaces through 
          a blend of manual and machine-based cleaning.
        </p>

        <p>
          Daily upkeep includes dusting, mopping, waste disposal, restroom hygiene 
          management, pantry cleanliness and overall facility sanitisation. For corporate 
          offices, we maintain reception zones, meeting rooms, executive cabins and 
          collaborative spaces. For industrial and warehouse environments, our teams manage 
          production-area cleanliness, floor care and safety-oriented housekeeping.
        </p>

        <p>
          We deploy both day and night shift teams depending on your operational workflow. 
          Our cleaning processes help improve hygiene ratings, extend floor life and support 
          a professional workplace experience across all the 15 cities we serve.
        </p>
      </div>

      {/* ICON 3 CARDS (IMAGE LEFT, TEXT RIGHT) */}
      <div className="hk2-icons">

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconTrusted} className="hk2-icon-img" alt="Trusted Service" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Trusted Service</h4>
            <p>Since 2019</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCoverage} className="hk2-icon-img" alt="Coverage" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Coverage</h4>
            <p>15 Cities</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCompliance} className="hk2-icon-img" alt="Compliance" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Compliance</h4>
            <p>100% Certified</p>
          </div>
        </div>

      </div>

    </section>
   
    </div>
  );
};

export default HousekeepingContent;
